// CSS
import "./BrandingPanel.css";

// IMAGES
import BrandingText from "../images/logos/branding-text.png"
import BrandingBackground from "../images/logos/branding-background.png"

/** 
 * This component renders the company logo overlayed on an image of a stream surrounded by trees.
 * 
 * @returns {ReactElement} A React element that renders a branding panel. 
 */
export default function BrandingPanel({}) {
    return (
        <div className="panel-column">
            <img className="panel-text" src={BrandingText} alt="Korotu - Sustainable Finance Technology"></img>
            <img className="panel-background" src={BrandingBackground} alt="A stream surrounded by trees"></img>
        </div>
    )
}